import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
import EditMixin from '@/components/core/dtwin/editMixin';
import detailsViewMixin from '@/components/core/virtualDevice/detailsViewMixin';
import GeoDataMixin from '@/components/core/dtwin/geoDataMixin';
import get from 'lodash/get';
import IsHeatMonitoringStateEdit from '@/components/is/heatMonitoring/stateEdit';

var defaultTab = function defaultTab(ctx) {
  if (ctx.$route.query.stateId) {
    return 'tab-states';
  }

  if (ctx.$route.query.ruleId) {
    return 'tab-rules';
  }

  if (ctx.$route.query.deviceinfo !== undefined) {
    return 'tab-deviceinfo';
  }

  return 'tab-dasbhoard';
};

export default {
  name: 'ViewISHeatMonitoringMeterDetails',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    IsHeatMonitoringStateEdit: IsHeatMonitoringStateEdit
  },
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles, detailsViewMixin],
  data: function data() {
    return {
      twinSelectionTreeMenu: true,
      tabItem: defaultTab(this),
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.twinObject.data.twinImageId);
      }

      return null;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    stateSourcesNameMapping: function stateSourcesNameMapping() {
      return {
        'virtual-device': this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'),
        'virtual-device-aggregate': "".concat(this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'), " ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.aggregate'))
      };
    }
  },
  watch: {},
  created: function created() {
    this.baseLink = 'is-heatmonitoring/meters';
    this.apiMethodGet = 'virtualDeviceGet';
    this.apiGeoHistoryFetchMethod = 'virtualDeviceFetchGeoHistory';
    this.apiMethodUpdate = 'virtualDeviceUpdate';
    this.apiMethodToggleDisabled = 'virtualDeviceUpdateDisabled';
    this.permissionSubject = 'VirtualDevice';
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    digitalTwinChanged: function digitalTwinChanged(selection) {
      if (parseInt(selection.id) !== parseInt(this.$route.params.id)) {
        this.$router.push("/is-heatmonitoring/meters/".concat(selection.id));
        this.twinSelectionTreeMenu = false;
      }

      this.twinSelectionTreeMenu = false;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      var ancestorList = this.ancestorList();
      var accountTitle = get(ancestorList, '[0].tenantName', undefined);
      var accountId = get(ancestorList, '[0].tenantId', undefined);

      if (accountTitle && accountId) {
        this.account = "".concat(accountTitle, " (ID: ").concat(accountId, ")");
      }

      if (ancestorList.length) {
        var queryId = "".concat(this.$route.params.id);
        return ancestorList.map(function (a) {
          var linkTarget = "/is-heatmonitoring/".concat("".concat(a.id) === queryId ? 'meters' : 'meter-points', "/").concat(a.id);

          if (a.parentId === null) {
            linkTarget = "/digitaltwin-mgmt/".concat(a.id);
          }

          return {
            to: linkTarget,
            text: a.parentId === null ? a.title : a.id
          };
        });
      }

      return [{
        to: '/is-heatmonitoring/meters',
        text: this.$i18n_t('Common.drawer.dTwins')
      }];
    }
  })
};